<template>
  <section>
    <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="150px">
      <section slot="area" slot-scope="prop">
        <treeselect
            :options="baseForm.areaOptions"
            placeholder="请选择行政区域名称"
            v-model="prop.form.area"
            :flatten-search-results="true"
            :clearable="false"
            @select="areaSelect"
        />
<!--        <treeselect-value :value="value" />-->
      </section>
    </qx-custom-form>

  </section>
</template>

<script>
import {dealNumber, dealZero} from '@qx/utils';
// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Treeselect,
  },
  data () {
    return {
      countryName: '',
      baseForm: {
        pts: null, // 圆形围栏中心点
        orgIdOptions: [], // 适用部门
        fenceShapeOptions: [], // 围栏形状
        areaOptions: [],
        alarmRadius: 1000,
        form: [
          {
            label: '围栏名称',
            value: 'name',
            type: 'input',
            placeholder: '请输入围栏名称',
          },
          {
            label: '围栏有效时间',
            value: 'effectiveTime',
            type: 'date',
            placeholder: '请选择有效时间区间',
            attr: {
              type: 'datetimerange',
            },
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() < Date.now() - 24 * 3600 * 1000;
              },
            },
          },
          {
            label: '限速值（km/h）',
            value: 'speedValue',
            type: 'input',
            placeholder: '请输入围栏内最高时速',
            onInput: (speedValue) => {
              this.$refs.baseForm.setVal('speedValue', dealZero(String(dealNumber(speedValue, false))), false);
            },
          },
          {
            label: '超速持续时间（秒）',
            value: 'overspeedDuration',
            type: 'input',
            placeholder: '请输入超速后最长持续时间',
            onInput: (overspeedDuration) => {
              this.$refs.baseForm.setVal('overspeedDuration', dealZero(String(dealNumber(overspeedDuration, false))), false);
            },
          },
          {
            label: '围栏形状',
            value: 'fenceShape',
            type: 'radio',
            default: '1',
            onChange: (fenceShape) => this.fenceShapeChange(fenceShape),
          },
          {
            label: '中心点坐标',
            value: 'centerMarker',
            type: 'input',
            placeholder: '请在地图上选择中心点坐标',
            hide: false,
            default: '',
            disabled: true,
          },
          {
            label: '报警半径（米）',
            value: 'alarmRadius',
            type: 'input',
            placeholder: '请输入报警半径',
            hide: false,
            default: 1000,
            onBlur: () => {
              const fenceShape = this.$refs.baseForm.getVal('fenceShape');
              const alarmRadius = this.$refs.baseForm.getVal('alarmRadius');
              this.baseForm.alarmRadius = alarmRadius;
              this.$emit('fenceShape', fenceShape, alarmRadius, this.pts);
            },
            onInput: (alarmRadius) => {
              this.$refs.baseForm.setVal('alarmRadius', dealZero(String(dealNumber(alarmRadius, false)), false));
            },
          },
          {
            label: '行政区域',
            value: 'area',
            slot: true,
            hide: true,
          },
          {
            label: '报警开关',
            value: 'alarmSwitch',
            type: 'checkbox',
            default: ['1', '2'],
            options: [
              {label: '进', value: '1'},
              {label: '出', value: '2'},
            ],
            onChangeCheckBox: () => {this.alarmPeriodChange();},
          },
          {
            label: '报警时段',
            value: 'alarmPeriod',
            type: 'radio',
            default: '1',
            options: [
              {label: '全天监测', value: '1'},
              {label: '指定时段', value: '2'},
            ],
            onChange: () => {this.alarmPeriodChange();},
          },
          {
            label: '进围栏报警开始时间',
            value: 'inFenceAlarmStartTime',
            type: 'date',
            placeholder: '请选择进围栏报警开始时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            hide: true,
          },
          {
            label: '进围栏报警结束时间',
            value: 'inFenceAlarmEndTime',
            type: 'date',
            placeholder: '请选择进围栏报警结束时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            hide: true,
          },
          {
            label: '出围栏报警开始时间',
            value: 'outFenceAlarmStartTime',
            type: 'date',
            placeholder: '请选择出围栏报警开始时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            hide: true,
          },
          {
            label: '出围栏报警结束时间',
            value: 'outFenceAlarmEndTime',
            type: 'date',
            placeholder: '请选择出围栏报警结束时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            hide: true,
          },
          {
            label: '适用部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择适用部门',
          },
          {
            label: '是否绘制电子围栏',
            value: 'isDraw',
            type: 'input',
            placeholder: '未绘制电子围栏',
            default: '',
            disabled: true,
          },
        ],
        rules: {
          name: [
            { required: true, message: '请输入围栏名称', trigger: 'blur' },
          ],
          effectiveTime: [
            { required: true, message: '请选择围栏有效时间', trigger: 'blur' },
          ],
          centerMarker: [
            { required: true, message: '请在地图上选择中心点坐标', trigger: 'blur' },
          ],
          alarmRadius: [
            { required: true, message: '请输入报警半径', trigger: 'blur' },
          ],
          area: [
            { required: true, message: '请选择行政区域名称', trigger: 'blur' },
          ],
          alarmSwitch: [
            { required: true, message: '请选择报警开关', trigger: 'blur' },
          ],
          inFenceAlarmStartTime: [
            { required: true, message: '请选择进围栏报警开始时间', trigger: 'blur' },
          ],
          inFenceAlarmEndTime: [
            { required: true, message: '请选择进围栏报警结束时间', trigger: 'blur' },
          ],
          outFenceAlarmStartTime: [
            { required: true, message: '请选择出围栏报警开始时间', trigger: 'blur' },
          ],
          outFenceAlarmEndTime: [
            { required: true, message: '请选择出围栏报警结束时间', trigger: 'blur' },
          ],
          isDraw: [
            { required: true, message: '请绘制电子围栏', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    centerMarker (data) {
      this.pts = data;
      this.$refs.baseForm.setVal('centerMarker', data.lng + ',' + data.lat, false);
    },
    draw (isDraw) {
      this.$nextTick(() => {
        this.$refs.baseForm.setVal('isDraw', isDraw ? '是' : '', false);
      });

    },
    async setList (options) {
      this.baseForm.fenceShapeOptions = options[0];
      this.baseForm.orgIdOptions = options[1];
      this.baseForm.areaOptions = options[2].items;
    },
    fenceShapeChange (val) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['area', 'alarmRadius', 'centerMarker'],
      });
      switch (val) {

        case '1':
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['alarmRadius', 'centerMarker'],
          });
          break;
        case '3':
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['area'],
          });
          break;
        default:
          break;
      }
      if (val === '1') {
        const alarmRadius = this.$refs.baseForm.getVal('alarmRadius');
        this.$emit('fenceShape', val, alarmRadius);
      } else if (val === '2') {
        this.$emit('fenceShape', val);
      } else {
        const area = this.$refs.baseForm.getVal('area');
        this.$emit('fenceShape', val, area);
      }
    },
    areaSelect (node, fenceShapeType) {
      this.countryName = typeof (node) === 'string' ? node : node.label;
      const fenceShape = '3';
      this.$emit('fenceShape', fenceShape, this.countryName);

    },
    alarmPeriodChange () {
      const alarmSwitch = this.$refs.baseForm.getVal('alarmSwitch');
      const alarmPeriod = this.$refs.baseForm.getVal('alarmPeriod');
      if (alarmPeriod === '2') {
        if (alarmSwitch.length > 1) {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['inFenceAlarmStartTime', 'inFenceAlarmEndTime', 'outFenceAlarmStartTime', 'outFenceAlarmEndTime'],
          });
        } else if (alarmSwitch.length === 0) {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['inFenceAlarmStartTime', 'inFenceAlarmEndTime', 'outFenceAlarmStartTime', 'outFenceAlarmEndTime'],
          });
        } else {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: alarmSwitch[0] === '1',
            names: ['outFenceAlarmStartTime', 'outFenceAlarmEndTime'],
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: alarmSwitch[0] === '2',
            names: ['inFenceAlarmStartTime', 'inFenceAlarmEndTime'],
          });
        }
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['inFenceAlarmStartTime', 'inFenceAlarmEndTime', 'outFenceAlarmStartTime', 'outFenceAlarmEndTime'],
        });
      }
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.effectiveStartTime = formData.effectiveTime ? this.formatDate(formData.effectiveTime[0], 1) : null; // 围栏有效开始时间
        formData.effectiveEndTime = formData.effectiveTime ? this.formatDate(formData.effectiveTime[1], 1) : null; // 围栏有效结束时间
        delete formData.effectiveTime;
        formData.alarmSwitch = formData.alarmSwitch.length < 2 ? Number(formData.alarmSwitch[0]) : 0;
        if (formData.alarmPeriod === '2') {
          formData.inFenceAlarmStartTime = this.formatDate(formData.inFenceAlarmStartTime, 1);//  进围栏报警开始时间
          formData.inFenceAlarmEndTime = this.formatDate(formData.inFenceAlarmEndTime, 1); // 进围栏报警结束时间
          formData.outFenceAlarmStartTime = this.formatDate(formData.outFenceAlarmStartTime, 1); // 出围栏报警开始时间
          formData.outFenceAlarmEndTime = this.formatDate(formData.outFenceAlarmEndTime, 1); // 出围栏报警结束时间
          if (formData.alarmSwitch === 1) {
            delete formData.outFenceAlarmStartTime;
            delete formData.outFenceAlarmEndTime;
          }
          if (formData.alarmSwitch === 2) {
            delete formData.inFenceAlarmStartTime;
            delete formData.inFenceAlarmEndTime;
          }
        }
        if (formData.fenceShape === '3') {
          formData.countryName = this.countryName;
        }

      }
      console.log('base参数', formData);
      return formData;
    },

    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      if (res.alarmPeriod === '1') {
        delete res.inFenceAlarmStartTime;
        delete res.inFenceAlarmEndTime;
        delete res.outFenceAlarmStartTime;
        delete res.outFenceAlarmEndTime;
      }
      return res;
    },
    async init (data = {}) {
      if (JSON.stringify(data) == '{}') {
        this.fenceShapeChange('1');
        this.$refs.baseForm.setVal('orgId', this.baseForm.orgIdOptions[0].value, false);
        return;
      }
      if (this.$route.query.type === 'view') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: true,
          names: ['name', 'effectiveTime', 'speedValue', 'overspeedDuration', 'fenceShape', 'alarmRadius', 'alarmSwitch', 'alarmPeriod', 'orgId'],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'disabled',
          value: false,
          names: ['name', 'effectiveTime', 'speedValue', 'overspeedDuration', 'fenceShape', 'alarmRadius', 'alarmSwitch', 'alarmPeriod', 'orgId'],
        });
      }
      data.fenceShape = data.circles ? '1' : data.polygons ? '2' : data.stations ? '3' : '1';
      this.fenceShapeChange(data.fenceShape);

      if (data.orgId === undefined || data.orgId === null) {
        data.orgId = this.baseForm.orgIdOptions[0].value;
      }
      if (data.alarmSwitch) {
        data.alarmSwitch = data.alarmSwitch === 0 ? ['1', '2'] : [String(data.alarmSwitch)];
      } else {
        data.alarmSwitch = ['1', '2'];
      }
      data.alarmPeriod = data.alarmPeriod ? String(data.alarmPeriod) : '1';
      data.effectiveTime = data.effectiveStartTime ? [this.formatDate(data.effectiveStartTime, 1), this.formatDate(data.effectiveEndTime, 1)] : '';
      if (data.fenceShape === '3' && data.stations) {
        if (typeof data.stations === 'string') {
          data.stations = JSON.parse(data.stations)[0];
        }
        data.area = data.stations.countrygb;
        data.countryName = data.stations.countryName;
        this.countryName = data.countryName;
        this.areaSelect(data.countryName, data.fenceShape);
      } else if (data.fenceShape === '1' && data.circles) {
        if (typeof data.circles === 'string') {
          data.circles = JSON.parse(data.circles)[0];
        }
        let point = {
          lat: data.circles.lat,
          lng: data.circles.lng,
        };
        this.pts = point;
        data.centerMarker = data.circles.lng + ',' + data.circles.lat;
        this.alarmRadius = data.circles.radius;
        data.alarmRadius = data.alarmRadius ? data.alarmRadius : data.circles.radius;
        this.$emit('fenceShape', data.fenceShape, data.alarmRadius, point);
      } else if (data.fenceShape === '2' && data.polygons) {
        if (typeof data.polygons === 'string') {
          data.polygons = JSON.parse(data.polygons)[0];
          if (typeof data.polygons.points === 'string') {
            data.polygons.points = JSON.parse(data.polygons.points);
          }
        }
        this.$emit('fenceShape', data.fenceShape, '', data.polygons.points);
      }
      this.$refs.baseForm.setVal(data);
      this.alarmPeriodChange();
    },
  },

};
</script>

<style scoped lang="scss">

</style>
